import { FC } from 'react'
import Row from '@components/row'
import Typography from '@components/typography'

interface AuthFooterProps {
  content: string
  tag?: string
  onClick?: () => void
}
const AuthFooter: FC<AuthFooterProps> = ({ content, tag, onClick }) => {
  return (
    <Row justifyContent="center" styleRow="margin-top:10px">
      <Row colGap={5}>
        <Typography content={content} size={12} tc="secondaryTextColor" />
        <Row onClick={onClick} styleRow="cursor:pointer">
          <Typography content={tag} size={12} tc="primary" />
        </Row>
      </Row>
    </Row>
  )
}
export default AuthFooter
